/** Человекочитаемое время уведомления: «только что» / «5 мин» / «2 ч» / дата. */
export const formatNotificationTime = (iso: string, locale: string, now: Date = new Date()): string => {
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ""
  const diffMs = now.getTime() - date.getTime()
  const diffSec = Math.round(diffMs / 1000)
  const diffMin = Math.round(diffMs / 60000)
  const diffHour = Math.round(diffMs / 3600000)
  const diffDay = Math.round(diffMs / 86400000)

  try {
    const rtf = new Intl.RelativeTimeFormat(locale, { numeric: "auto" })
    if (diffSec < 60) return rtf.format(-diffSec, "second")
    if (diffMin < 60) return rtf.format(-diffMin, "minute")
    if (diffHour < 24) return rtf.format(-diffHour, "hour")
    if (diffDay < 7) return rtf.format(-diffDay, "day")
    return new Intl.DateTimeFormat(locale, { day: "2-digit", month: "short", year: "numeric" }).format(date)
  } catch {
    return date.toLocaleDateString()
  }
}
